import React, { useRef, useEffect } from "react";
import { MenuButton } from "./MenuButton";

export function ActionsMenu({
  isOpen,
  onToggle,
  onClose,
  onAddNote,
  onAssignCourier,
  onChangeStatus,
  onDelete,
}: {
  isOpen:          boolean;
  onToggle:        (e: React.MouseEvent) => void;
  onClose:         () => void;
  onAddNote:       () => void;
  onAssignCourier: () => void;
  onChangeStatus:  () => void;
  onDelete:        () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen, onClose]);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={onToggle}
        className="p-1 rounded hover:bg-gray-200 transition-colors text-gray-400 hover:text-gray-600"
        title="Actions"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <circle cx="8" cy="3" r="1.5" />
          <circle cx="8" cy="8" r="1.5" />
          <circle cx="8" cy="13" r="1.5" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 top-8 z-50 w-44 bg-white rounded-lg shadow-lg border border-gray-200 py-1">
          <MenuButton onClick={onAddNote}>Add note</MenuButton>
          <MenuButton onClick={onAssignCourier}>Assign courier</MenuButton>
          <MenuButton onClick={onChangeStatus}>Change status</MenuButton>
          <div className="border-t border-gray-100 my-1" />
          <MenuButton onClick={onDelete} danger>Delete item</MenuButton>
        </div>
      )}
    </div>
  );
}
